import { Button, type ButtonProps } from '@imprivata-cloud/components';
import { Form } from 'antd';
import type { NamePath } from 'antd/es/form/interface';
import type { FormInstance } from 'antd/lib';
import './ContinueButton.less';

export const checkFormErrors = <FormItems,>(form: FormInstance<FormItems>) =>
  (form.getFieldsError() || []).some(field => !!field.errors.length);

const isDisabled = <FormItems,>(
  form: FormInstance<FormItems>,
  errorCheck?: (form: FormInstance<FormItems>) => boolean,
  validateDirty?: boolean | Array<NamePath<FormItems>>,
) => {
  const hasErrors = errorCheck ? errorCheck(form) : checkFormErrors(form);
  let isDirty: boolean;
  if (!validateDirty) {
    isDirty = true;
  } else if (Array.isArray(validateDirty)) {
    isDirty = form.isFieldsTouched(validateDirty, true);
  } else {
    isDirty = form.isFieldsTouched(true);
  }
  return hasErrors || !isDirty;
};

export interface ContinueButtonProps<FormItems> extends ButtonProps {
  secondaryButton?: ButtonProps;
  validateDirty?: boolean | Array<NamePath<FormItems>>;
  overrideErrorCheck?: (form: FormInstance<FormItems>) => boolean;
}

export const ContinueButton = <FormItems,>({
  secondaryButton,
  overrideErrorCheck,
  validateDirty,
  disabled,
  ...props
}: ContinueButtonProps<FormItems>) => {
  return (
    <Form.Item shouldUpdate>
      {form => (
        <div className="continue-button">
          <Button
            size="large"
            type="primary"
            disabled={disabled || isDisabled(form, overrideErrorCheck, validateDirty)}
            block
            {...props}
            className={props.className}
          />
          {secondaryButton && <Button {...secondaryButton} type="text" />}
        </div>
      )}
    </Form.Item>
  );
};

export default ContinueButton;
